(() => {
  "use strict";

  const instances = new WeakMap();

  const init = (root) => {
    if (!root || instances.has(root)) return;

    const image = root.querySelector(".wb-hero-she__img");
    const parallax = Number(root.dataset.parallax || 0);

    requestAnimationFrame(() => {
      root.classList.add("is-loaded");
    });

    if (!image || parallax === 0 || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      instances.set(root, {
        destroy: () => {}
      });
      return;
    }

    let ticking = false;

    const update = () => {
      const rect = root.getBoundingClientRect();

      if (rect.bottom > 0 && rect.top < window.innerHeight) {
        const progress = Math.max(0, Math.min(1, -rect.top / rect.height));
        image.style.transform = `scale(1) translateY(${progress * parallax}%)`;
      }

      ticking = false;
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);

    update();

    instances.set(root, {
      destroy: () => {
        window.removeEventListener("scroll", onScroll);
        window.removeEventListener("resize", onScroll);
        instances.delete(root);
      }
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll("[data-wb-hero-she]").forEach(init);
  };

  document.addEventListener("DOMContentLoaded", () => {
    initAll(document);
  });

  document.addEventListener("shopify:section:load", (event) => {
    initAll(event.target);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    event.target.querySelectorAll("[data-wb-hero-she]").forEach((root) => {
      const instance = instances.get(root);

      if (instance && typeof instance.destroy === "function") {
        instance.destroy();
      }
    });
  });
})();